const actions = {
  setLanguage({ commit }, languages) {
    commit('SET_LANGUAGE', languages)
  } 
}

export default actions

